import API, { APIPath } from '../apis/api'
import { GetImageResponse } from '../apis/response/GetImageResponse'
import { ProductCardProp } from '../components/product-card'
import { GetDepartmentResponse } from '../apis/response/GetDepartmentResponse'
import { TranslationService } from './TranslationService'
import { GetSubCatResponse } from '../apis/response/GetSubCatResponse'

class ImageStorageService {
    GetRandomCatCover = async (cat: string) => {
        const catCover: GetImageResponse = (await API.ImageStorage.GetCategoryCover(`${cat}`)).obj
        const randomId = Math.round(Math.random() * (catCover.items.length - 1))
        const cover = this.FormatImageSrc(catCover.items[randomId].stream_id)
        return cover
    }

    GetRandomCardProps = async (take?: number) => {
        const num = take ?? 6
        const res: GetImageResponse = (await API.ImageStorage.GetRandomImage()).obj
        const cards: ProductCardProp[] = res.items.map(x => {
            const name = this.FormatProduct(x.name!)
            return {
                link: this.FormatImageSrc(x.stream_id, x.file_type),
                // slug: this.FormatProduct(x.name!)[0].toLowerCase().replace('s', ''),
                slug: name[0],
                key: x.stream_id,
                title: name[1].replace('.' + name[1].split('.').filter((v, i, a) => i == a.length - 1)[0], ''),
                isProduct: false,
                subCat: `/SubCat/${this.FormatProduct(x.subcat!)[0]}`,
                display_order:0
            }
        })
        return cards
    }

    GetDepartmentList = async (category: string) => {
        const res: GetDepartmentResponse = (await API.Category.GetDepartments(category)).obj
        const depts = res.items.map(x => x.dept_id)
        const service = new TranslationService
        let cards: ProductCardProp[] = []
        for (const d of depts) {
            const r: GetImageResponse = (await API.ImageStorage.GetDeptCover(d)).obj
            const obj = r.items[0]
            const card: ProductCardProp = {
                link: this.FormatImageSrc(obj.stream_id, obj.file_type),
                slug: `/Department/${d}`,
                subCat: `/Department/${d}`,
                key: obj.stream_id,
                title: res.items[depts.indexOf(d)].dept_display_name,
                translation: service.ConvertDepartmentName(res.items[depts.indexOf(d)]),
                isProduct: false,
                display_order:parseInt((await API.Category.GetDepartmentInfo(`${d}`)).obj.items[0].display_order)
            }
            cards.push(card)
        }
        return cards
    }

    GetSubCatList = async (dept: string) => {
        const res: GetImageResponse = (await API.ImageStorage.GetSubCatList(dept)).obj
        const service = new TranslationService
        let cards: ProductCardProp[] = []
        for (const x of res.items) {
            const info: GetSubCatResponse = (await API.Category.GetSubCatInfo(this.FormatProduct(x.name!)[0])).obj
            const card = {
                link: this.FormatImageSrc(x.stream_id, x.file_type),
                slug: `/SubCat/${this.FormatProduct(x.name!)[0]}`,
                subCat: `/SubCat/${this.FormatProduct(x.name!)[0]}`,
                key: x.stream_id,
                title: this.FormatProduct(x.name!)[1],
                isProduct: false,
                translation: service.ConvertSubCatName(info.items[0]),
                display_order: parseInt((await API.Category.GetSubCatInfo(`${this.FormatProduct(x.name!)[0]}`)).obj.items[0].display_order)
            }
            cards.push(card)
        }
        return cards
    }

    GetSubCatCards = async (sc: string) => {
        const res: GetImageResponse = (await API.ImageStorage.GetSubCat(sc)).obj
        const cards: ProductCardProp[] = res.items.map(x => {
            const name = this.FormatProduct(x.name!)
            return {
                link: this.FormatImageSrc(x.stream_id, x.file_type),
                slug: name[0].toLowerCase().replace('s', ''),
                key: x.stream_id,
                title: name[1].replace('.' + name[1].split('.').filter((v, i, a) => i == a.length - 1)[0], ''),
                isProduct: false,
                modal: true,
                display_order:0
            }
        })
        return cards
    }

    SearchProductByKeyword = async (key: string) => {
        const res: GetImageResponse = (await API.ImageStorage.Search(key)).obj
        let cards: ProductCardProp[] = []
        if (res.items == undefined || res.items.length == 0) {
            return cards
        }
        try {
            cards = res.items.map(x => {
                const name = this.FormatProduct(x.name!)
                return {
                    link: this.FormatImageSrc(x.stream_id, x.file_type),
                    // slug: name[0].toLowerCase().replace('s', ''),
                    slug: name[0],
                    key: x.stream_id,
                    title: name[1].replace('.' + name[1].split('.').filter((v, i, a) => i == a.length - 1)[0], ''),
                    isProduct: false,
                    subCat: `/SubCat/${this.FormatProduct(x.subcat!)[0]}`,
                    display_order:0,
                }
            })
            return cards
        } catch (err) {
            return cards
        }
    }

    FormatImageSrc = (stream_id: string, file_type?: string) => {
        return `${APIPath.BasePath}/img?key=${stream_id}`
    }
    FormatProduct = (name: string) => {
        const n = name.split(' ')
        return [n[0], n.filter((x, idx) => idx != 0).join(' ')]
    }
}

export default ImageStorageService